module.exports = __webpack_public_path__ + "media/images/flags/cc-200233c98efe5d026e98498cf8969844.svg";